import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import api from "@/lib/api";

let initialized = false;
let notificationNavigate = null;
let pendingNotificationCode = null;

export function setPushNotificationNavigate(navigate) {
  notificationNavigate = navigate;

  if (pendingNotificationCode) {
    const code = pendingNotificationCode;
    pendingNotificationCode = null;
    notificationNavigate(`/codes/${encodeURIComponent(code)}`);
  }
}

function openOrderFromNotification(data) {
  const code = data?.code;
  if (!code) return;

  if (!notificationNavigate) {
    pendingNotificationCode = code;
    return;
  }

  notificationNavigate(`/codes/${encodeURIComponent(code)}`);
}

export async function initPushNotifications(user) {
  if (!user || initialized) return;
  if (!Capacitor.isNativePlatform()) return;

  initialized = true;

  try {
    let permStatus = await PushNotifications.checkPermissions();

    if (permStatus.receive === "prompt") {
      permStatus = await PushNotifications.requestPermissions();
    }

    if (permStatus.receive !== "granted") {
      console.log("[KAPEI Push] Permiso no concedido");
      return;
    }

    PushNotifications.addListener("registration", async (token) => {
      console.log("[KAPEI Push] Token recibido", token.value);
      try {
        await api.post("/push/register", {
          token: token.value,
          platform: "android",
        });
      } catch (e) {
        console.error("[KAPEI Push] Error guardando token", e);
      }
    });

    PushNotifications.addListener("registrationError", (error) => {
      console.error("[KAPEI Push] Error registro", error);
    });

    PushNotifications.addListener("pushNotificationReceived", (notification) => {
      console.log("[KAPEI Push] Notificación recibida", notification);
    });

    PushNotifications.addListener("pushNotificationActionPerformed", (notification) => {
      console.log("[KAPEI Push] Notificación pulsada", notification);
      openOrderFromNotification(notification.notification?.data);
    });

    await PushNotifications.register();
  } catch (e) {
    console.error("[KAPEI Push] Error inicializando", e);
  }
}
